import { configureStore } from '@reduxjs/toolkit'
import headerSlice from '../features/common/headerSlice'
import modalSlice from '../features/common/modalSlice'
import rightDrawerSlice from '../features/common/rightDrawerSlice'
import leadsSlice from '../features/leads/leadSlice'
import ConfirmedOrdersReducer from '../features/confirmedOrders/confirmedOrderSlice'
import NewOrdersReducer from '../features/newOrders/newOrderSlice'
import ManageShipmentsReducer from '../features/manageShipments/manageShipmentsSlice'
import CreateNewShipmentReducer from '../features/createNewShipment/createNewShipmentSlice'
import OpsConfirmedOrdersReducer from '../features/opsConfirmedOrders/opsConfirmedOrdersSlice'
import opsAllPendingOrdersReducer from '../features/opsAllPendingOrders/opsAllPendingOrderSlice'
import OpsVendorPendingOrdersReducer from '../features/opsVendorPendingOrders/opsVendorPendingOrdersSlice'
import UserLoginReducer from '../features/user/loginSlice'

import MyOrdersReducer from '../features/myOrders/myOrdersSlice'
import ShippingPlatformReducer from '../features/shippingPlatform/shippingPlatformSlice'
import ShipmentManagement from '../features/shipmentManagement/shipmentManagementSlice'
import QCPlatform from '../features/qcPlatform/qcPlatformSlice'
import IndiaQCPlatform from '../features/indiaQcPlatform/indiaQcPlatformSlice'
import IndiaInwardPlatform from '../features/indiaInwardPlatform/indiaInwardPlatformSlice'
import invoicePlatform from '../features/InvoicePlatform/invoicePlatformSlice'
import vendorInventoryPlatform from '../features/VendorInventoryPlatform/vendorInventorySlice'
import sharedInventoryPlatform from '../features/sharedInventoryPlatform/sharedInventorySlice'
import orderManagementPlatform from '../features/orderManagementPlatform/orderManagementSlice'
import priceNegotiation from '../features/priceNegotiation/priceNegotiationSlice'
import materialUnitSlice from '../features/materialUnit/materialUnitSlice'
import productionUnitSlice from '../features/productionUnit/productionUnitSlice'
import supplyHeaderSlice from '../features/common/supplyManagementHeaderSlice'
import shipmentUnitSlice from '../features/shipmentUnit/shipmentUnitSlice'
import sourceBulkInventorySlice from '../features/sourceBulkInventory/sourceBulkInventorySlice'
import inventoryManagementSlice from '../features/inventoryManagement/inventoryManagementSlice'
import printStickerSlice from '../features/printStickeringLabel/stickeringSlice'
import vendorClearanceSlice from '../features/vendorClearance/vendorClearanceSlice'
import accessoryManagementSlice from '../features/accessoryManagement/accessoryManagementSlice'
import sampleManagementSlice from '../features/sampleManagement/sampleManagementSlice'
import fabricManagementSlice from '../features/fabricManagement/fabricManagementSlice'
import reportPlatformSlice from '../features/reportPlatform/reportPlatformSlice'
import ChinaCatalogueSlice from '../features/chinaCatalogueManagement/chinaCatalogueSlice'
import ChinaCatalogueReviewSlice from '../features/chinaCatalogueReview/chinaCatalogueReviewSlice'
import BuyerReviewCatalogueSlice from '../features/buyerCatalogueReview/buyerCatalogueReviewSlice'
import VendorQCPlatformSlice from '../features/vendorQcPlatform/vendorQcPlatformSlice'
import ProductMappingSlice from '../features/productMapping/productMappingSlice'

// import IndiaBuyerReviewCatalogueSlice from '../features/indiaBuyerCatalogueReview/indiaBuyerCatalogueReviewSlice'
// import IndiaCatalogueSlice from '../features/indiaCatalogueManagement/indiaCatalogueSlice'

import ChinaSampleQcSlice from '../features/chinaSampleQC/chinaSampleQcSlice'
import apiLoggerSlice from '../features/common/apiLoggerSlice'
import garmentSpecificationsDetailsSlice  from '../features/indiaGarmentSpecifications/indiaGarmentSpecificationsSlice'
import indiaStyleSurveySlice  from '../features/indiaStyleSurvey/indiaStyleSurveySlice'
import finalMeasurementsPlatform  from '../features/finalMeasurements/finalMeasurementSlice'
import sampleCostingPlatform  from '../features/sampleCosting/sampleCostingSlice'
import replenishmentPoModelSlice  from '../features/replenishmentPOModel/replenishmentPoModelSlice'
import refreshmentPoModelSlice  from '../features/refreshmentPoModel/refreshmentPoModelSlice'
import allocationDashboardSlice  from '../features/allocationDashboard/allocationDashboardSlice'
import { takeAction } from '../utils/apiTrackUtil'
import profile  from '../features/createNewAccount/profileSlice'
import userDashboardPlatform from '../features/userDashboard/userDashboardSlice'
import PreProductionSlice from '../features/preProduction/preProductionSlice'
import lowInventoryDashboardSlice from '../features/lowInventoryDashboard/lowInventorySlice'

import indiaShipmentManagementSlice from '../features/indiaShipmentManagement/indiaShipmentManagementSlice'
import indiaInvoiceManagementSlice from '../features/indiaInvoiceManagement/indiaInvoiceManagementSlice'
import gateEntrySlice from '../features/gateEntry/gateEntrySlice';
import putawaySlice from '../features/putaway/putawaySlice';
import inventoryQcGrnSlice from '../features/inventoryQcGrn/inventoryQcGrnSlice';
import GlobalComponentManagment from "../components/componentsSlice"
import fabricMoSlice from '../features/fabricMO/fabricMoSlice';
import dispatchSlice from '../features/Dispatch/dispatchSlice';
import pickingPackingSlice from '../features/pickingPacking/pickingPackingSlice';
import SplittingPlatform from '../features/SplittingPlatform/splittingPlatformSlice'
import paymentManagementSlice from '../features/paymentManagement/paymentManagementSlice'

const combinedReducer = {
  header: headerSlice,
  supplyHeader: supplyHeaderSlice,
  rightDrawer: rightDrawerSlice,
  modal: modalSlice,
  lead: leadsSlice,
  confirmedOrders: ConfirmedOrdersReducer,
  newOrders: NewOrdersReducer,
  manageShipments: ManageShipmentsReducer,
  createNewShipment: CreateNewShipmentReducer,
  opsConfirmedOrders: OpsConfirmedOrdersReducer,
  opsAllPendingOrders: opsAllPendingOrdersReducer,
  opsVendorPendingOrders: OpsVendorPendingOrdersReducer,
  userLogin: UserLoginReducer,
  myOrders: MyOrdersReducer,
  shippingPlatformItems: ShippingPlatformReducer,
  shipmentManagementItems: ShipmentManagement,
  qcPlatformItems: QCPlatform,
  indiaQCPlatformItems: IndiaQCPlatform,
  indiaInwardPlatformItems: IndiaInwardPlatform,
  invoicePlatform: invoicePlatform,
  vendorInventoryPlatform: vendorInventoryPlatform,
  sharedInventoryPlatform: sharedInventoryPlatform,
  priceNegotiationItems: priceNegotiation,
  orderManagementPlatform: orderManagementPlatform,
  materialUnitPlatform: materialUnitSlice,
  productionUnitPlatform: productionUnitSlice,
  shipmentUnitPlatform: shipmentUnitSlice,
  sourceBulkInventoryPlatform: sourceBulkInventorySlice,
  inventoryManagementPlatform: inventoryManagementSlice,
  printStickers: printStickerSlice,
  apiLogger: apiLoggerSlice,
  vendorClearance: vendorClearanceSlice,
  accessoryManagement: accessoryManagementSlice,
  sampleManagement: sampleManagementSlice,
  fabricManagement: fabricManagementSlice,
  report: reportPlatformSlice,
  chinaCatalogueManagement: ChinaCatalogueSlice,
  chinaCatalogueReviewManagement: ChinaCatalogueReviewSlice,
  buyerReviewCatalogueManagement: BuyerReviewCatalogueSlice,
  vendorQCPlatform: VendorQCPlatformSlice,
  productMapping: ProductMappingSlice,
  // indiaBuyerReviewCatalogueManagement: IndiaBuyerReviewCatalogueSlice,
  // indiaCatalogueManagement: IndiaCatalogueSlice,
  finalMeasurements: finalMeasurementsPlatform,
  sampleCosting: sampleCostingPlatform,
  chinaQcSample: ChinaSampleQcSlice,
  garmentSpecificationsDetails: garmentSpecificationsDetailsSlice,
  indiaStyleSurvey: indiaStyleSurveySlice,
  userProfile: profile,
  userDashboard: userDashboardPlatform,
  preproduction: PreProductionSlice,
  userDashboard: userDashboardPlatform,
  indiaShipment: indiaShipmentManagementSlice,
  indiaInvoice: indiaInvoiceManagementSlice,
  lowInventoryDashboardPlatform: lowInventoryDashboardSlice,
  replenishmentPoModel: replenishmentPoModelSlice,
  refreshmentPoModel: refreshmentPoModelSlice,
  allocationDashboard: allocationDashboardSlice,
  gateEntryPlatform: gateEntrySlice,
  putawayPlatform: putawaySlice,
  inventoryQcGrn: inventoryQcGrnSlice,
  globalComp: GlobalComponentManagment,
  fabricMo: fabricMoSlice,
  dispatchPlatform: dispatchSlice,
  pickingPackingPlatform: pickingPackingSlice,
  splittingPlatform: SplittingPlatform,
  paymentManagement: paymentManagementSlice
};

const excludeApis = {
  'trackUserApiActions': true
}

const requestStatusAllowed = ['pending', 'fulfilled']
const requestStatusMap = {
  pending: 'request_sent',
  fulfilled: 'response_received',
}

const extractDateFormat = (date) => {
  const result =  date?.toISOString()?.split(/T|Z/)
  return result[0] + " " + result[1]
}

const myLoggingMiddleware = (_) => (next) => (action) => {
  // Here you have access to `action.type` and `action.payload`
  if (action?.meta?.requestStatus && requestStatusAllowed?.includes(action?.meta?.requestStatus) && !excludeApis[action?.meta?.type?.split('/')[0]] ) {
    const payload = {
      event_timestamp: extractDateFormat(new Date()),
      frontend_request_id: action?.meta?.requestId,
      action_type: requestStatusMap[action?.meta?.requestStatus],
      ...(action?.meta?.requestStatus === 'fulfilled' && {backend_trace_id: action?.payload?.data?.trace_id})
    }
    if (action?.meta?.requestStatus !== 'fulfilled' || action?.payload?.data?.trace_id) {
      takeAction(payload)
    }
  }
  
  // You should always do this at the end of your middleware
  return next(action)
}

export default configureStore({
  reducer: combinedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(myLoggingMiddleware)
})